import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    width: 100%;
  }

  body {
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: ${props => props.theme.typography.fontSize.base};
    color: ${props => props.theme.colors.text.primary};
    background-color: transparent;
    line-height: 1.6;
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
    position: relative;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${props => props.theme.typography.fontWeight.semibold};
    line-height: 1.3;
    margin-bottom: ${props => props.theme.spacing.md};
  }

  h1 {
    font-size: ${props => props.theme.typography.fontSize.xxxl};
  }

  h2 {
    font-size: ${props => props.theme.typography.fontSize.xxl};
  }

  h3 {
    font-size: ${props => props.theme.typography.fontSize.xl};
  }

  h4 {
    font-size: ${props => props.theme.typography.fontSize.lg};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: color ${props => props.theme.transitions.fast};

    &:hover {
      text-decoration: underline;
    }
  }

  button {
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    border: none;
    outline: none;
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    border: 1px solid ${props => props.theme.colors.border};
    outline: none;
    
    &:focus {
      border-color: ${props => props.theme.colors.primary};
    }
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};
    width: 100%;
    overflow-x: hidden;
  }
  
  /* Prevenir scroll horizontal en todos los elementos */
  #root {
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }
  
  /* Asegurar que las imágenes no causen overflow */
  img {
    max-width: 100%;
    height: auto;
  }
  
  /* Prevenir que las tablas causen overflow */
  table {
    max-width: 100%;
    overflow-x: auto;
    display: block;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  /* Asegurar que todos los contenedores sean transparentes */
  #root, #root > div {
    background: transparent !important;
  }
  
  /* Asegurar que el layout principal sea transparente */
  main {
    background: transparent !important;
  }

  @media print {
    body {
      background: white;
    }
  }
`;